<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/3.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Return Policy</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>Return Policy</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<!--section  -->
<section class="no-top-padding-sec" data-scrollax-parent="true">
    <div class="container">
        <div class="user-profile-header_content">
            <div class="ab_text-title fl-wrap">
                <h4>Return Policy </h4>
                <span class="section-separator fl-sec-sep"></span>
            </div>
            <p>
            We offer return within first 7 days from the date of your purchase. If 7 days have passed
            since your purchase, you will not be offered a return, exchange or refund of any kind. In order to become
            eligible for a return or an exchange,</p>
            <p> (i) The purchased item should be unused and in the same condition as
            you received it,</p>
            <p> (ii) The item must have original packaging, </p>
            <p>(iii) If the item that you purchased on a sale,
            then the item may not be eligible for a return / exchange. Further, only such items are replaced by us
            (based on an exchange request), if such items are found defective or damaged.</p>

            <p>You agree that there may be a certain category of products / items that are exempted from returns or
            refunds. Such categories of the products would be identified to you at the item of purchase. For exchange
            / return accepted request(s) (as applicable), once your returned product / item is received and inspected
            by us, we will send you an email to notify you about receipt of the returned / exchanged product. Further.</p>

            <p>If the same has been approved after the quality check at our end, your request (i.e. return / exchange) will
            be processed in accordance with our policies.</p>

            <p>If Shopping will provide the platform for buyers and sellers to interact and come to terms in case of any product returns. For any queries please mail us at <a href="mailto:support@businessinmaharashtra.com">support&#64;businessinmaharashtra.com</a> .</p>
            
        </div>
    </div>
</section>
<!--section end-->